import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';
import { useSessao } from '../../nucleo/sessao';

/** Fase 2 (W8): o fluxo detalhado grava só no modo detalhado de Compras. No simplificado, as abas ficam só para consulta. */
export function useFluxoDetalhado(): boolean {
  return useSessao().modo('compras.modo') === 'detalhado';
}

const ESCRITA_DETALHADA = new Set(['compras.criar', 'compras.editar', 'compras.excluir', 'compras.aprovar', 'compras.cancelar', 'compras.receber']);

/**
 * A sessão vista pelas telas do fluxo detalhado: `pode` nega a escrita fora do modo detalhado. O servidor recusa do mesmo
 * jeito (409 `modo.indisponivel`); aqui é só para o botão não aparecer. Fase 2 (W25, K14): o recebimento não depende mais do
 * Estoque (sem ele, confirma o pedido e gera a conta a pagar, sem movimentar estoque).
 */
export function useSessaoFluxo() {
  const s = useSessao();
  const detalhado = s.modo('compras.modo') === 'detalhado';
  return { ...s, pode: (p: string) => s.pode(p) && (!ESCRITA_DETALHADA.has(p) || detalhado) };
}

/** O Estoque é dependência opcional do Compras: com ele o recebimento dá entrada na mercadoria; sem ele, só confirma e lança a conta. */
export function useComEstoque(): boolean {
  return useSessao().instalado('estoque');
}

/**
 * Aviso no topo das abas do fluxo detalhado: histórico só leitura no modo simplificado e, no recebimento, Estoque não
 * instalado. Some quando não há nada a avisar.
 */
export function AvisoModo({ recebimento }: { recebimento?: boolean }) {
  const { t } = useTranslation('compras');
  const detalhado = useFluxoDetalhado();
  const comEstoque = useComEstoque();
  const textos = [!detalhado && t('historico.simplificado'), recebimento && !comEstoque && t('historico.semEstoque')].filter((x): x is string => !!x);
  if (!textos.length) return null;
  return (
    <div role="note" className="flex items-start gap-2 rounded-lg border border-borda bg-sup-2 px-3 py-2 text-sm text-tinta-2">
      <Info className="mt-0.5 size-4 shrink-0 text-ciano" aria-hidden />
      <div className="flex min-w-0 flex-col gap-1">
        {textos.map((x) => (
          <p key={x}>{x}</p>
        ))}
      </div>
    </div>
  );
}
